var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 96,
    viewBox: "0 0 114 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2131_886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7288 89.9328L14.1338 78.8702L16.0669 75.3411L21.7155 89.9328L23.5421 94.6511L20.7288 89.9328Z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3934 89.9328L18.7477 93.1322L17.0276 89.9328L12.5928 81.6854L13.3302 80.3384L17.3934 89.9328Z",
    fill: "#1D232A",
    stroke: "#00A868",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.645 96H20.5906C20.5906 95.9596 20.5826 95.9191 20.5665 95.8807L18.0487 89.9328L13.7002 79.663L13.7987 79.485L20.028 89.9328L23.645 96Z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3954 89.9327L28.6025 96H24.7122L22.3631 89.9327L16.4473 74.6473L16.8873 73.8424L25.3954 89.9327Z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0173 89.9327L33.2478 96H29.2851L26.078 89.9327L17.2344 73.2074L21.0463 66.2462L21.826 64.9337L31.0173 89.9327Z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.476 96H33.8915L31.661 89.9328L22.2246 64.2643L47.3489 21.923V21.921L50.2988 16.9519C50.3008 16.9519 50.3008 16.9499 50.3008 16.9499L54.1369 10.4862C55.6902 7.86721 58.2281 6.4131 60.8766 6.12187C64.1862 5.75986 67.6645 7.21397 69.6077 10.4862L112.212 82.282C115.799 88.3249 111.473 96 104.476 96Z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1963 95.8301C17.0878 95.8301 16.9853 95.7714 16.9311 95.6703L12.0863 86.6281L14.8593 95.2072C14.9116 95.367 14.8252 95.5368 14.6664 95.5894C14.5077 95.642 14.3389 95.555 14.2866 95.3953L10.4807 83.6228C10.4325 83.4731 10.5048 83.3113 10.6495 83.2507C10.7922 83.19 10.959 83.2466 11.0333 83.3862L15.7475 92.1817L13.4266 85.3257C13.3723 85.1679 13.4567 84.994 13.6155 84.9414C13.7742 84.8868 13.945 84.9717 13.9973 85.1315L17.4837 95.4337C17.5339 95.5834 17.4636 95.7472 17.3189 95.8099C17.2787 95.822 17.2365 95.8301 17.1963 95.8301Z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7331 89.9332H9.52399C2.52705 89.9332 -1.79931 82.2582 1.78757 76.2152L44.3921 4.41951C47.8886 -1.47179 56.3685 -1.47179 59.865 4.41951L60.8757 6.12238L102.47 76.2152C106.056 82.2582 101.728 89.9332 94.7331 89.9332Z",
    fill: "#F1BD38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0844 67.5345C52.0804 67.5345 52.0764 67.5345 52.0744 67.5345C49.4119 67.5284 47.2557 65.3503 47.2617 62.6706L47.3501 21.4133C47.3562 18.7356 49.5143 16.5696 52.1728 16.5696C52.1769 16.5696 52.1809 16.5696 52.1829 16.5696C54.8454 16.5757 57.0016 18.7539 56.9955 21.4336L56.9071 62.6908C56.9011 65.3685 54.7429 67.5345 52.0844 67.5345Z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1287 82.6217C55.4714 82.6217 58.1812 79.8945 58.1812 76.5302C58.1812 73.166 55.4714 70.4387 52.1287 70.4387C48.786 70.4387 46.0762 73.166 46.0762 76.5302C46.0762 79.8945 48.786 82.6217 52.1287 82.6217Z",
    fill: "#1D232A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2131_886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 96,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.48a0da9db172364789e754cb106881fc.svg";
export { ForwardRef as ReactComponent };